// extracted by mini-css-extract-plugin
export default {"tabsFooter":"styles_tabsFooter__1fSKG","footerBtn":"styles_footerBtn__NafTq","goalsList":"styles_goalsList__SoEAu","crown":"styles_crown__+eNCJ"};